import { CMSApi } from "./axios";

const basePath = "contact/v1";

export default {
  sendEmailMessage(data) {
    return CMSApi.post(`${basePath}/send`, { ...data });
  }
};
